import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import toast from "react-hot-toast";
import { Toaster } from "@jti/ui";
const ToasterBlock = ({ id }) => {
    useEffect(() => {
        // For handling toast messages from outside of react
        document.addEventListener("toast_error", (event) => {
            if (event.detail.id === id) {
                toast.error(event.detail.message);
            }
        });
    }, []);
    return (_jsx("div", { children: _jsx(Toaster, {}) }));
};
export default ToasterBlock;
//# sourceMappingURL=Toaster.js.map